import React, { useState, useEffect } from "react";
import ProductDetailSlider from "src/Components/WebsiteComponents/ProductDetailSlider";
import AddCartComponent from "src/Components/Customer/ProductsAndServicesComponents/AddCartComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faLocationDot,
  faPlus,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import {
  convertToKebabCase,
  getLoginUserID,
  getShippingAddresses,
  parseQueryParams,
  printAddress,
} from "src/helpers/helperFunctions";
import CounterComponent from "src/Components/Customer/ProductsAndServicesComponents/CounterComponent";
import ProductReview from "src/Components/Customer/ProductsAndServicesComponents/ProductReview";
import GradientBtn from "src/Components/WebsiteComponents/GradientBtn";
import HistoryIcon from "src/assets/images/website-images/history-icon.png";
import CarIcon from "src/assets/images/website-images/carIcon.png";
import PhoneIcon from "src/assets/images/website-images/phoneIcon.png";
import CircleIcon from "src/assets/images/website-images/circleIcon.png";
import DangerImg from "src/assets/images/website-images/danger.png";
import OgxImg from "src/assets/images/website-images/Ogx.png";
import DummyProduct from "src/assets/images/product-dummy-img.png";
import { ChevronRight } from "lucide-react";
import BannerImage1 from "src/assets/images/website-images/banner-image-1.png";
import BannerImage2 from "src/assets/images/website-images/banner-image-2.png";
import BoxWrapper from "src/Components/WebsiteComponents/BoxWrapper";
import { DummyText } from "src/lib/DummmyData";
import { IAddressData } from "src/types/GlobalInterfaces";
import { capitalize, IconButton, Skeleton } from "@mui/material";
import PharmaCard from "src/Components/WebsiteComponents/HomePage/Cards/PharmaCard";
import ProductViewSection from "src/Components/WebsiteComponents/HomePage/ProductViewSection";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/Store/store";
import CartDrawer from "src/Components/AdminComponents/CartDrawer";
import ManageAddressScreen from "src/Components/AllTabs/ManageAddressScreen";
import {
  CURRENCY,
  FREE_DELIVERY_AMOUNT,
  ImageBaseUrl,
  QueryPath,
} from "src/lib/constans";
import PriceView from "src/Components/GlobalComponents/PriceView";
import FrequentlyBoughtCarousels from "../Carousel/FrequentlyBoughtCarousels";
import { removeAllDisLike } from "src/Store/disLike";

interface ProductDocument {
  _id: string;
  productName: string;
  outOfStock: number;
  averageRating: number;
  quantity: number;
  regularPrice: number;
  salePrice: number | null;
  status: boolean;
  startDate: string;
  endDate: string;
  images: string;
  galleryImages: string[];
  shortDescription: string;
  overview: string;
  brandName: string;
  brandId: string;
  mainCategoryName: string;
  mainCategoryId: string;
  subCategoryName: string;
  subCategoryId: string;
  childCategoryName: string;
  childCategoryId: string;
  prescriptionRequired: boolean;
  promotionalTagDetails: {
    _id?: string;
    name?: string;
    color?: string;
  };
  productTagsName: string[];
  productTags: string[];
  frequentlyBoughtDetails: any[];
  deliveryType: string;
  sku: string;
  [key: string]: any;
}

const PharmaProductDetail: React.FC = () => {
  const { id } = useParams();
  const { address } = useSelector((state: RootState) => state?.cartSlice);
  const [count, setCount] = useState<number>(1);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [isYouMayAlsoLikeLoader, setIsYouMayAlsoLikeLoader] =
    useState<boolean>(false);
  const [youMayAlsoLike, setYouMayAlsoLike] = useState<ProductDocument[]>([]);
  const [item, setItem] = useState<ProductDocument | null>(null);
  const [selectedFrequently, setSelectedFrequently] = useState<number[]>([
    0, 1,
  ]);
  const [currentAddress, setCurrentAddress] = useState<
    IAddressData | null | string
  >(null);
  const navigate = useNavigate();
  const [showAddressModal, setShowAddressModal] = useState<boolean>(false);
  const { pharmacyDisLike } = useSelector((state: RootState) => state.disLike);
  const dispatch = useDispatch<AppDispatch>();
  const fetchYouMayAlsoLike = async (brandId: string) => {
    setIsYouMayAlsoLikeLoader(true);
    const { res, err } = await httpRequest<ProductDocument[]>({
      path: `/pharma-inventory/you-may-like/${brandId}?userId=${getLoginUserID()}`,
    });
    if (res) {
      setYouMayAlsoLike(res.map((v) => ({ ...v, mainImage: v?.image })));
    } else {
      toast(err, { type: "error" });
    }
    setIsYouMayAlsoLikeLoader(false);
  };

  const fetch = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<{ document: ProductDocument }>({
      path: `/pharma-inventory/home/${id}?userId=${getLoginUserID()}`,
    });
    if (res) {
      setItem(res?.document);
      fetchYouMayAlsoLike(res?.document?.brandId || "");
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetch();
  }, [id]);
  const [mainImage, setMainImage] = useState<string>("");
  const handleThumbnailClick = (imageSrc: string) => {
    setMainImage(imageSrc);
  };

  useEffect(() => {
    if (item && item?.images) {
      setMainImage(item.images);
    }
  }, [item?.images]);

  useEffect(() => {
    if (pharmacyDisLike.length > 0) {
      let updatedStatusData = {
        ...item,
        isLiked: pharmacyDisLike.find((i) => i === item?._id)
          ? false
          : item?.isLiked,
      }
      setItem(updatedStatusData as ProductDocument);
      dispatch(removeAllDisLike("pharmacyDisLike"));
    }
  }, [pharmacyDisLike]);

  return (
    <>
      <CartDrawer
        isOpen={showAddressModal}
        onClose={() => setShowAddressModal(false)}
      >
        <ManageAddressScreen onBack={() => setShowAddressModal(false)} />
      </CartDrawer>
      <div className="w-full py-4">
        <div className="view-area-width box-design p-2.5 2xl:p-4 flex flex-col gap-2.5 2xl:gap-4">
          <div className="w-full flex flex-col md:flex-row gap-2.5 2xl:gap-4 bg-white rounded-md">
            <div className="w-full flex flex-col lg:flex-row gap-5 lg:gap-2.5 2xl:gap-4 md:w-[70%]">
              <div className="w-full lg:w-[45%]">
                <ProductDetailSlider
                  galleryImages={[item?.images, ...(item?.galleryImages || [])]}
                  onThumbnailClick={handleThumbnailClick}
                  isLiked={item?.isLiked || false}
                  productId={item?._id || ""}
                  shareOptions={{
                    text: `${capitalize(
                      item?.brandName || ""
                    )} - Product Id is ${item?._id}`,
                    title: `${capitalize(item?.productName || "")}`,
                  }}
                  onLikeProduct={(id, isLiked) => {
                    setItem({
                      ...item,
                      isLiked: isLiked,
                    } as ProductDocument);
                  }}
                  loading={isLoader}
                  addiltionContent={
                    item?.promotionalTagDetails ? (
                      <div
                        className="py-1 px-2 w-fit bg-[#08911F] text-[#FFFFFF] rounded-[5px] font-size-15px flex justify-center items-center font-Lexend-Regular absolute left-3 bottom-3"
                        style={{
                          backgroundColor:
                            item?.promotionalTagDetails?.color || "#08911F",
                        }}
                      >
                        {item?.promotionalTagDetails?.name}
                        <img src={DangerImg} alt="Danger" className="pl-2" />
                      </div>
                    ) : null
                  }
                  salePrice={item?.salePrice || 0}
                  regularPrice={item?.regularPrice || 0}
                />
              </div>

              {/* Middle Column - Product Info */}
              <div className="w-full space-y-2.5 2xl:space-y-4 lg:w-[55%]">
                <div className="box-design w-full relative">
                  <div className="flex w-full items-center gap-3 py-1 2xl:py-2 px-1 2xl:px-2">
                    {/* Brand Logo */}
                    <div className="w-14 h-14 bg-white rounded-md box-design p-0.5 overflow-hidden flex items-center justify-center">
                      {isLoader ? (
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height="100%"
                          className="rounded-md"
                        />
                      ) : (
                        <img
                          src={item?.brandLogo}
                          alt="Ogx"
                          className="w-full h-full object-contain"
                        />
                      )}
                    </div>

                    {/* Brand Info */}
                    <div>
                      {isLoader ? (
                        <Skeleton
                          variant="text"
                          width="80%"
                          height={20}
                          className="rounded-md "
                        />
                      ) : (
                        <h2 className="text-[#2D2D2D] lowercase first-letter:capitalize font-Poppins-Medium font-size-16px">
                          {item?.brandName}
                        </h2>
                      )}
                      {isLoader ? (
                        <Skeleton
                          variant="text"
                          width="120px"
                          height={20}
                          className="rounded-md "
                        />
                      ) : (
                        <button
                          className="text-[#3B82F6] cursor-pointer hover:underline font-Poppins-Regular font-size-14px"
                          onClick={() => {
                            let q = parseQueryParams({
                              [QueryPath.brand]: item?.brandId || "",
                              [QueryPath.brandName]: item?.brandName || "",
                            });
                            navigate(
                              `/brand/${convertToKebabCase(
                                item?.brandName || ""
                              )}?${q}`
                            );
                          }}
                        >
                          Explore all the products
                        </button>
                      )}
                    </div>
                    {!isLoader && (
                      <IconButton
                        sx={{
                          position: "absolute",
                          right: 10,
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                        onClick={() => {
                          let q = parseQueryParams({
                            [QueryPath.brand]: item?.brandId || "",
                            [QueryPath.brandName]: item?.brandName || "",
                          });
                          navigate(
                            `/brand/${convertToKebabCase(
                              item?.brandName || ""
                            )}?${q}`
                          );
                        }}
                      >
                        <ChevronRight className="text-[#00443F]" size={20} />
                      </IconButton>
                    )}
                  </div>
                </div>
                <div>
                  {isLoader ? (
                    <div>
                      <Skeleton
                        variant="text"
                        width="80%"
                        height={28}
                        className="rounded-md "
                      />
                      <Skeleton
                        variant="text"
                        width="50%"
                        height={28}
                        className="rounded-md "
                      />
                    </div>
                  ) : (
                    <h1 className="text-[#393939] font-Lexend-Regular font-size-25px">
                      {item?.productName || "Product Name Not Found"}
                    </h1>
                  )}
                  {!isLoader && (
                    <p className="text-[#F59E0B] mt-2">
                      {[1, 2, 3, 4, 5].map((v) => (
                        <FontAwesomeIcon
                          key={v}
                          className={
                            (item?.averageRating || 0) >= v
                              ? "text-[#facc15] font-size-20px"
                              : "text-[#b7b6b1] font-size-20px"
                          }
                          icon={faStar}
                        />
                      ))}
                      <span className="text-[#707070] font-Poppins-Regular font-size-16px">
                        {" "}
                        {item?.averageRating
                          ? item?.averageRating.toFixed(1)
                          : "0.0"}{" "}
                        -{" "}
                        {item?.ratingsCount
                          ? item?.ratingsCount.toString().padStart(2, "0")
                          : 0}{" "}
                        Review{item?.ratingsCount && item?.ratingsCount > 1 ? "s" : ""}
                      </span>
                      <span
                        className={
                          "px-3 py-2 bg-[#F8FAFC] border border-[#F8FAFC] rounded-[25px] ml-4 font-Poppins-Regular font-size-15px text-[#707070]"
                        }
                      >
                        SKU : {item?.sku || "N/A"}
                      </span>
                    </p>
                  )}
                  {item?.productTags &&
                  item?.productTagsName &&
                  item?.productTags?.length > 0 &&
                  item?.productTagsName?.length > 0 ? (
                    <div className="flex gap-2 mt-5">
                      {isLoader
                        ? Array.from({ length: 2 }).map((item, index) => (
                            <Skeleton
                              variant="rectangular"
                              width="30%"
                              height={"2vw"}
                              className="rounded-md "
                              key={`skeleton-${index}`}
                            />
                          ))
                        : item?.productTags?.map(
                            (tag: string, index: number) => (
                              <button
                                className="bg-[#F1F5F9] px-3 text-left py-2 rounded-[10px] text-[#363636] font-Poppins-Regular font-size-14px "
                                onClick={() => {
                                  navigate(
                                    `/brand/${convertToKebabCase(
                                      `${item?.brandName}` || ""
                                    )}/${convertToKebabCase(
                                      `${item?.productTagsName[index]}` || ""
                                    )}?${parseQueryParams({
                                      [QueryPath.brand]: item?.brandId || "",
                                      [QueryPath.brandName]:
                                        item?.brandName || "",
                                      [QueryPath.productTag]:
                                        item?.productTags[index] || "",
                                      [QueryPath.productTagName]:
                                        item?.productTagsName[index] || "",
                                    })}`
                                  );
                                }}
                              >
                                {item?.productTagsName[index]}
                              </button>
                            )
                          )}
                    </div>
                  ) : null}
                </div>
                <div className="flex items-center justify-between gap-4">
                  {isLoader ? (
                    <Skeleton
                      variant="rectangular"
                      width="20%"
                      height={"1.7vw"}
                      className="rounded-md "
                    />
                  ) : (
                    <PriceView
                      salePrice={item?.salePrice || 0}
                      regularPrice={item?.regularPrice || 0}
                      className="!font-Poppins-SemiBold font-size-26px-important !text-[#202020]"
                      fontFamily="font-Poppins-SemiBold"
                      fontFamilyRegular="font-Poppins-Regular"
                      regularClassName="text-[#434343] font-size-19px-important"
                      saleClassName="!text-[#202020] font-size-26px-important"
                    />
                  )}
                  {!isLoader && (
                    <div className="flex gap-2 items-center">
                      <span className="text-[#363636] font-Poppins-Regular font-size-16px">
                        Quantity
                      </span>
                      <CounterComponent
                        type="pharmacy"
                        productId={item?._id || ""}
                        updateCount={(val: number) => {}}
                        stockQuantity={item?.quantity || 0}
                        bgColor
                        checkCart
                        onCountChange={(val: number) => {
                          setCount(val);
                        }}
                      />
                    </div>
                  )}
                </div>
                {isLoader ? (
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={"2.1vw"}
                    className="rounded-full min-h-8"
                  />
                ) : (
                  <AddCartComponent
                    textBtn={true}
                    btnFull
                    productId={item?._id || ""}
                    type="pharmacy"
                    prescriptionRequired={item?.prescriptionRequired || false}
                    stockQuantity={item?.quantity || 0}
                    quantity={1}
                    count={count}
                  />
                )}

                {/* Frequently Bought Together */}
                <FrequentlyBoughtCarousels
                  data={item?.frequentlyBoughtDetails || []}
                  isLoading={isLoader}
                />
              </div>
            </div>

            {/* Right Column - Delivery Info */}
            <div className="w-full space-y-2.5 2xl:space-y-4 md:w-[30%]">
              <div className="box-design rounded-[10px] p-3">
                <div className="w-full flex gap-3 justify-between">
                  <div className="flex-1 flex gap-2 items-center max-w-[calc(100%-100px)]">
                    <div className="min-w-[30px] min-h-[30px] xl:min-w-[2vw] xl:min-h-[2vw]  bg-[#E6EEFF] rounded-md flex items-center justify-center">
                      <FontAwesomeIcon
                        icon={faLocationDot}
                        className="text-[#2563EB] xl:text-[1.2vw]"
                      />
                    </div>
                    <div className="flex flex-col font-size-15px">
                      {isLoader ? (
                        <Skeleton
                          variant="text"
                          width="20%"
                          height={"1.3vw"}
                          className="rounded-md min-w-[60px] min-h-5"
                        />
                      ) : (
                        <p className="text-[#2F2F31] font-Poppins-Medium">
                          Deliver To:
                        </p>
                      )}
                      {isLoader ? (
                        <Skeleton
                          variant="text"
                          width="50%"
                          height={"1.3vw"}
                          className="rounded-md min-w-[120px] min-h-5"
                        />
                      ) : (
                        <p className="line-clamp-1 text-[#5B5B5B] font-Poppins-Regular">
                          {printAddress(address || "", false)}
                        </p>
                      )}
                    </div>
                  </div>
                  {isLoader ? (
                    <Skeleton
                      variant="rectangular"
                      width="20%"
                      height={"1.6vw"}
                      className="rounded-md min-w-[80px] min-h-6"
                    />
                  ) : (
                    <GradientBtn
                      ButtonText="Change"
                      onPress={() => setShowAddressModal(true)}
                      fontfamilyBtn="font-Poppins-Medium"
                      fontsizeBtn="font-size-14px"
                      btnExtraStyle={{
                        borderRadius: 5,
                        padding: "4px 1rem",
                      }}
                    />
                  )}
                </div>

                <div className="bg-[#F0FDF4] border border-[#22C55E] p-2 rounded-[10px] mt-4">
                  <div className="flex gap-3 items-center">
                    <div>
                      <img src={HistoryIcon} alt="history_icon" />
                    </div>
                    <div>
                      {isLoader ? (
                        <Skeleton
                          variant="text"
                          width="20%"
                          height={"1.3vw"}
                          className="rounded-md min-w-[60px] min-h-5"
                        />
                      ) : (
                        <p className="flex gap-2 text-[#202020] font-Poppins-Regular font-size-15px">
                          Express Delivery
                        </p>
                      )}
                      {isLoader ? (
                        <Skeleton
                          variant="text"
                          width="50%"
                          height={"1.3vw"}
                          className="rounded-md min-w-[120px] min-h-5"
                        />
                      ) : (
                        <p className="text-[#5B5B5B] font-Poppins-Regular font-size-14px">
                          In{" "}
                          {item?.deliveryType === "standard"
                            ? "24 hours"
                            : "30 min"}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {!isLoader && (
                <div className="w-full box-design flex flex-col">
                  <div className=" flex gap-3 items-center border-b border-[#E6E6E6] p-3 ">
                    {/* <div className="w-[35px] flex items-center justify-center"> */}
                    <img src={CarIcon} alt="car_icon" className="w-[30px]" />
                    {/* </div> */}
                    <div>
                      <p className="text-[#2F2F31] font-Poppins-Medium font-size-15px">
                        Free Delivery
                      </p>
                      <p className="text-[#5B5B5B] font-Poppins-Regular font-size-15px ">
                        Enjoy free delivery on all orders over {CURRENCY}{" "}
                        {FREE_DELIVERY_AMOUNT}
                      </p>
                      <a
                        href="#"
                        className="text-[#3B82F6] underline hover:opacity-80 font-Poppins-Regular font-size-15px"
                      >
                        Learn More
                      </a>
                    </div>
                  </div>
                  <div className=" flex gap-3 items-center p-3 ">
                    <div className="h-fit flex items-center justify-center">
                      <img
                        src={PhoneIcon}
                        alt="car_icon"
                        className="w-[30px]"
                      />
                    </div>
                    <div>
                      <p className="text-[#2F2F31] font-Poppins-Medium font-size-15px">
                        24/7 Customer Support
                      </p>
                      <p className="text-[#5B5B5B] font-Poppins-Regular font-size-15px ">
                        Receive dedicated support around the clock
                      </p>
                      <a
                        href="#"
                        className="text-[#3B82F6] underline hover:opacity-80 font-Poppins-Regular font-size-15px"
                      >
                        Learn More
                      </a>
                    </div>
                  </div>
                  {/* <div className=" flex gap-3 items-center p-3 ">
                    <div>
                      <img
                        src={CircleIcon}
                        alt="car_icon"
                        className="w-[30px]"
                      />
                    </div>
                    <div>
                      <p className="text-[#2F2F31] font-Poppins-Medium font-size-15px">
                        Easy Return
                      </p>
                      <p className="text-[#5B5B5B] font-Poppins-Regular font-size-15px ">
                        Benefit from our hassle-free return and refund policy
                      </p>
                      <a
                        href="#"
                        className="text-[#3B82F6] underline hover:opacity-80 font-Poppins-Regular font-size-15px"
                      >
                        Learn More
                      </a>
                    </div>
                  </div> */}
                </div>
              )}
            </div>
          </div>
          {item?.salesBanners && item?.salesBanners?.length > 0 && (
            <div className="flex w-full gap-3">
              {item?.salesBanners?.map((banner: any, index: number) => (
                <img
                  key={index}
                  src={banner}
                  alt="sales_banner"
                  className="w-1/2 rounded-md xl:max-h-[250px] max-h-[220px] object-cover"
                />
              ))}
            </div>
          )}
          <BoxWrapper
            title="Overview"
            extraTextStyle={{
              fontFamily: "Lexend-Medium",
              color: "#3E3E3E",
            }}
            productDetailBoxDesign
            loading={isLoader}
          >
            {isLoader ? (
              <div>
                <Skeleton
                  variant="text"
                  width="90%"
                  height={"1.5vw"}
                  className="rounded-md min-h-4 "
                />
                <Skeleton
                  variant="text"
                  width="80%"
                  height={"1.5vw"}
                  className="rounded-md min-h-4 "
                />
              </div>
            ) : (
              <div
                contentEditable="false"
                className="!font-[Lexend-Regular] font-size-18px text-[#707070]"
                dangerouslySetInnerHTML={{ __html: item?.overview || "" }}
              />
            )}
          </BoxWrapper>

          <BoxWrapper
            title="Description"
            extraTextStyle={{
              fontFamily: "Lexend-Medium",
              color: "#3E3E3E",
            }}
            productDetailBoxDesign
            titleClass="!border-b-0 !pb-2 !xl:pb-0 !-mb-2"
            loading={isLoader}
          >
            {isLoader ? (
              <div>
                <Skeleton
                  variant="text"
                  width="90%"
                  height={"1.5vw"}
                  className="rounded-md min-h-4 "
                />
                <Skeleton
                  variant="text"
                  width="80%"
                  height={"1.5vw"}
                  className="rounded-md min-h-4 "
                />
              </div>
            ) : (
            <div
              contentEditable="false"
              className="!font-[Lexend-Regular] font-size-18px text-[#707070]"
              dangerouslySetInnerHTML={{ __html: item?.productDetails || "" }}
            />
            )}
          </BoxWrapper>

          <ProductReview productId={id} />
          {youMayAlsoLike?.length > 0 && (
            <ProductViewSection
              title="You May Also Like"
              secondTitle="Based on what customers bought"
              data={youMayAlsoLike}
              renderProduct={(data) => <PharmaCard product={data} />}
              isLoading={isYouMayAlsoLikeLoader}
              renderSkeleton={<PharmaCard skeleton />}
              className="!w-full"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default PharmaProductDetail;
